import { B100, N900 } from '@atlaskit/theme/colors';
import { borderRadius } from '@atlaskit/theme/constants';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { Link } from '../search-link-component';
import { dialogWidth } from '../style-utils';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SearchFooterLinksContainer = styled.div({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'start',
  flexDirection: 'row',
  padding: "var(--ds-space-150, 12px)".concat(" ", "var(--ds-space-200, 16px)"),
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  maxWidth: dialogWidth,
  color: "var(--ds-text, ".concat(N900, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LabelContainer = styled.div({
  marginRight: "var(--ds-space-050, 4px)",
  flexShrink: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TruncatedTextDiv = styled.div({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var PrimaryButtonWrapper = styled.div({
  flex: '1 1 0',
  overflow: 'hidden',
  maxWidth: 'max-content',
  marginRight: "var(--ds-space-025, 2px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var PrimaryButtonStyledLink = styled(Link)({
  display: 'flex',
  textOverflow: 'ellipsis',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderRadius: "".concat(borderRadius(), "px"),
  transitionDuration: '0.2s',
  transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
  '&:focus': {
    outline: 'none',
    boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")"), " inset")
  },
  '&:hover': {
    textDecoration: 'none'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DropownMenuLink = styled(Link)({
  display: 'block',
  position: 'relative',
  '&:focus': {
    outline: "2px solid ".concat("var(--ds-border-focused, ".concat(B100, ")")),
    outlineOffset: '-2px'
  },
  '&:hover': {
    textDecoration: 'none'
  }
});